import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';
import { NavigationBar } from '../../Components/NavigationBar/NavigationBar';
import { ModalMessage } from '../../Components/ModalMessage/ModalMessage';
import { useDeleteAccount } from '../../hooks/useDeleteAccount';
import './ProfilePage.css';

const ProfilePage = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showExclusionModal, setShowExclusionModal] = useState(false);
    const { deleteAccount, loading, error, success } = useDeleteAccount();

    const handleBack = () => {
        navigate('/');
    };

    const handleModalDismiss = () => {
        setShowModal(false);
    };

    const handleModalConfirm = () => {
        navigate('/login');
        localStorage.removeItem('token');
        handleModalDismiss();
    };

    const handleLogout = () => {
        setShowModal(true);
    };

    const handleDeleteAccount = () => {
        setShowExclusionModal(true);
    };

    const [errorMessage, setErrorMessage] = useState(null);

    const handleDeleteConfirm = async () => {
        setErrorMessage(null);
        await deleteAccount();
        if (success) {
            navigate('/login');
            setShowExclusionModal(false);
        } else if (error) {
            setErrorMessage(error);
        }
    };

    const menuItems = [
        {
            title: 'Política de Privacidade',
            action: () => navigate('/privacy-policy'),
            danger: false
        },
        {
            title: 'Termos de Uso',
            action: () => navigate('/terms-of-service'),
            danger: false
        },
        {
            title: 'Alterar Senha',
            action: () => navigate('/change-password'),
            danger: false
        },
        {
            title: 'Sair do App',
            action: handleLogout,
            danger: false
        },
        {
            title: 'Excluir Conta',
            action: handleDeleteAccount,
            danger: true
        }
    ];

    return (
        <div className="profile-page-profile-container">
            <NavigationBar onBackClick={handleBack} title="Perfil" />
            <div className="profile-page-profile-content">
                <div className="profile-icon-container">
                    <div className="profile-icon">
                        <FaUser />
                    </div>
                </div>
                {menuItems.map((item, index) => (
                    <button
                        key={item.title}
                        className={`profile-page-profile-button ${item.danger ? 'danger' : ''}`}
                        onClick={item.action}
                    >
                        {item.title}
                    </button>
                ))}
            </div>
            
            {showModal && (
                <ModalMessage
                    title="Sair do app"
                    description="Tem certeza que deseja deixar o aplicativo?"
                    leftButtonText="Sim"
                    leftButtonAction={handleModalConfirm}
                    rightButtonText="Não"
                    rightButtonAction={handleModalDismiss}
                />
            )}

            {showExclusionModal && (
                <ModalMessage
                    title="Excluir conta"
                    description={
                        loading 
                            ? "Excluindo sua conta..." 
                            : "Tem certeza que deseja excluir sua conta? Esta ação não pode ser desfeita."
                    }
                    leftButtonText={loading ? "Aguarde..." : "Sim, excluir"}
                    leftButtonAction={handleDeleteConfirm}
                    rightButtonText="Cancelar"
                    rightButtonAction={() => {
                        setShowExclusionModal(false);
                        setErrorMessage(null);
                    }}
                />
            )}
            {errorMessage && (
                <ModalMessage
                    title="Erro ao excluir conta"
                    description={errorMessage}
                    leftButtonText="Tentar novamente"
                    leftButtonAction={handleDeleteConfirm}
                    rightButtonText="Cancelar"
                    rightButtonAction={() => {
                        setErrorMessage(null);
                        setShowExclusionModal(false);
                    }}
                />
            )}
        </div>
    );
};

export default ProfilePage;
